import { Action, Module, VuexModule } from "vuex-module-decorators";
import { FeedbackType } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class FeedbackTypeModule extends VuexModule {
    @Action
    [FeedbackType.getFeedbackTypeList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/feedbackType/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [FeedbackType.findPageFeedbackType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/feedbackType`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [FeedbackType.saveFeedbackType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/feedbackType/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [FeedbackType.deleteFeedbackType](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/feedbackType/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}